<template>
  <transition enter-active-class="animate__animated animate__fadeIn" leave-active-class="animate__animated animate__fadeOut" name="fade" mode="out-in">
    <component :is="appropriateComponent" />
  </transition>
</template>

<script>
import Stations from '@trust/components/views/Stations.vue'
import Public from '@trust/components/views/Public.vue'
import { VueCookieNext } from 'vue-cookie-next';

export default {
  components: {
    Stations,
    Public
  },
  computed: {
    appropriateComponent() {
      let hasToken = VueCookieNext.getCookie('token');
      return hasToken == null ? "Public" : "Stations";
    }
  }
};
</script>
